import http from "@/http/axios";
import { appModule } from "@/store/modules/app";


export async function getAccountList() {
  const result = await http.get("/accounts");
  if (result) {
    if (result.data.status === "Success") {
      return result.data.data.accounts;
    } else {
      appModule.sendErrorNotice("取得列表失敗");
    }
  } else {
    appModule.sendErrorNotice("取得列表失敗");
  }
}

export async function replaceRole(replaceItem) {
  const params = {
    roles: replaceItem.roles
  };
  const result = await http.post(
    "/user/" + replaceItem.uuid + "/roles",
    params
  );
  if (result) {
    if (result.data.status === "Success") {
      appModule.sendSuccessNotice("修改成功");
    } else {
      appModule.sendErrorNotice("修改失敗");
    }
  }
}

export async function getPatientsByAccount(accountId, patientOptions) {
  const result = await http.get(`/user/${accountId}/patients?q=${patientOptions.q}&page=${patientOptions.page}&limit=10`);
  if (result) {
    if (result.data.status === "Success") {
      return result.data.data;
    } else {
      appModule.sendErrorNotice("取得列表失敗");
    }
  } else {
    appModule.sendErrorNotice("取得列表失敗");
  }
}

export async function getPatientsNeedToAdd(accountId, patientOptions) {
  const result = await http.get(`/user/${accountId}/patients?mode=not&q=${patientOptions.q}&page=${patientOptions.page}&limit=10&role=Patient`);
  if (result) {
    if (result.data.status === "Success") {
      return result.data.data;
    } else {
      appModule.sendErrorNotice("取得列表失敗");
    }
  } else {
    appModule.sendErrorNotice("取得列表失敗");
  }
}

export async function getAllPatientsByAccount(accountId: string) {
  const first = await getPatientsByAccount(accountId, { q: "", page: 1 });
  if (!first) return [];
  const allPatients = [...first.patients];
  const totalPages: number = first.total_page;
  if (totalPages > 1) {
    const requests = [];
    for (let page = 2; page <= totalPages; page++) {
      requests.push(getPatientsByAccount(accountId, { q: "", page }));
    }
    const results = await Promise.all(requests);
    for (const result of results) {
      if (result) allPatients.push(...result.patients);
    }
  }
  return allPatients;
}

export async function addPatientsToAccount(accountId, params) {
  const result = await http.post(
    "/user/" + accountId + "/patients",
    params
  );
  if (result) {
    if (result.data.status === "Success") {
      appModule.sendSuccessNotice("變更成功");
    } else {
      appModule.sendErrorNotice("變更失敗");
    }
  } else {
    appModule.sendErrorNotice("變更失敗");
  }
}
